<template>
    <div class="container">
        <header class="py-4 mb-12 border-bottom">
            <div class="row align-items-start">
                <div class="col">
                    <div class="col-md-4 px-0">
                        <img src="@/assets/sonnen-logo.svg" class="img-responsive" alt="Responsive image" />
                    </div>
                    <router-link to="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark">
                        <span class="fs-4">VPPp cabinet check</span></router-link
                    >
                </div>
                <div class="col">
                    <b-form-input
                        @keydown.native="test_keydown_handler"
                        sm="2"
                        aria-describedby="input-live-help input-live-feedback"
                        trim
                        disabled
                        v-model="miObject"
                        placeholder="Enter MI object"
                    ></b-form-input>
                </div>

                <div class="col">
                    <p class="text-right">
                        <b-icon icon="person-fill"></b-icon> &nbsp;
                        <i>{{ this.$session.get("fullname") }}</i>
                        &nbsp; &nbsp;
                        <button style="float: right" v-on:click="logout" class="btn btn-primary btn-sm" v-if="isLoggedIn">
                            Logout
                        </button>
                        <button style="float: right" class="btn btn-secondary btn-sm" v-else disabled>Logout</button>
                    </p>
                </div>
            </div>
        </header>
    </div>
</template>

<script>
export default {
    name: "HeaderView",
    data() {
        return {
            miObject: ""
        };
    },
    computed: {
        isLoggedIn() {
            // `this` points to the component instance
            return this.$store.state.user.loggedIn || this.$session.exists();
        }
    },
    mounted() {
        console.log("mounting header", this.$session.id());
    },
    methods: {
        test_keydown_handler(event) {
            if (event.which === 13) {
                console.log(event);
                console.log("switching to ", this.miObject);

                this.$router.go("/meter/" + this.miObject).catch((err) => {
                    console.log(err);
                });
            }
        },
        logout() {
            console.log("logout", this.$session.id());
            this.$store.state.user.loggedIn = false;
            if (this.$session.exists) {
                this.$session.destroy();
            }
            this.$router.go("/").catch(() => {});
        }
    }
};
</script>
